export const SLIDESHOW_GET = 'SLIDESHOW_GET';